import { GridToolbarQuickFilter, GridToolbarExport } from '@mui/x-data-grid'
import { Grid } from '@mui/material'
import useStyles from './style'
import moment from 'moment'

const DataGridFilters = (props) => {
  const classes = useStyles()
  const { fileName } = props
  return (
    <>
      <Grid container className={classes.quickFilter}>
        <Grid item xs={12} className={classes.filterWrapper}>
          <GridToolbarQuickFilter debounceMs={500} />
          <GridToolbarExport
            csvOptions={{
              fileName: `${
                fileName ? fileName : 'jums_datasheet'
              }_${moment().format('DDMMYYYY')}_${moment().format('hhmm')}`,
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default DataGridFilters
